/* jshint undef: true, unused: true */

var nJ = {};

nJ.deepMerge = function(target, source) {
  return Object.assign(
    target,
    Object.entries(source).reduce(function(carry, entry) {
      var key = entry[0];
      var value = entry[1];
      carry[key] =
        value && value.constructor === {}.constructor
          ? nJ.deepMerge(carry[key] || {}, value)
          : value;
      return carry;
    }, target)
  );
};

nJ.addClass = function( elem, className ) {
  if (elem) {
    if (typeof className !== 'undefined' && className !== null && className !== '') {
      if (className.constructor === Array) {
        className.forEach(function(value) {
          nJ.addClass(elem, value);
        });
      }else{
        elem.classList.add(className);
      }
    }
  } else {
    console.error('Element not defined. Unable to add class(es)', className);
  }
};

nJ.removeClass = function( elem, className ) {
  if (elem) {
    if (elem && typeof className !== 'undefined' && className !== null && className !== '') {
      if (className.constructor === Array) {
        className.forEach(function(value) {
          nJ.removeClass(elem, value);
        });
      }else{
        elem.classList.remove(className);
      }
    }
  } else {
    console.error('Element not defined. Unable to remove class(es)', className);
  }
};

nJ.allArrayValuesAreEqual = function ( array ) {
  var i;

  for(i = 1; i < array.length; i++) {
    if(array[i] !== array[0])
      return false;
  }
  return true;
};


// from:https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
(function (arr) {
  arr.forEach(function (item) {
    if (item.hasOwnProperty('remove')) {
      return;
    }
    Object.defineProperty(item, 'remove', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function remove() {
        if (this.parentNode !== null)
          this.parentNode.removeChild(this);
      }
    });
  });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);


// source: https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
(function() {
  if (typeof window.CustomEvent === 'function') {
    return false;
  }

  function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;
})();

module.exports = nJ;

